// === Task 38 === Single suggestion card used inside SuggestionsRail.
// Stateless presentational component: receives a WorkflowSuggestionList item
// + UI locale + picked flag, exposes a single onPick(suggestion) callback.
// Title/summary are `{en, tr}` bilingual maps (Task 34); we fall back to `en`
// when the active locale's translation is missing.
import React from "react";

export default function SuggestionCard({ suggestion, locale, picked, onPick }) {
  if (!suggestion) return null;
  const lang = locale === "tr" ? "tr" : "en";
  const title = (suggestion.title && (suggestion.title[lang] || suggestion.title.en)) || "";
  const summary = (suggestion.summary && (suggestion.summary[lang] || suggestion.summary.en)) || "";
  const shape = suggestion.shape || {};
  const hints = Array.isArray(shape.pluginKindHints) ? shape.pluginKindHints : [];

  return (
    <button
      type="button"
      className={`suggestion-card${picked ? " suggestion-card--picked" : ""}`}
      onClick={() => onPick && onPick(suggestion)}
      aria-pressed={!!picked}
    >
      <div className="suggestion-card__head">
        <span className="suggestion-card__icon" aria-hidden="true">
          ⚡
        </span>
        <span className="suggestion-card__title">{title}</span>
      </div>
      {summary && <div className="suggestion-card__summary">{summary}</div>}
      <div className="suggestion-card__meta">
        {shape.estimatedSceneCount > 0 && <span>{shape.estimatedSceneCount} scenes</span>}
        {hints.map((k) => (
          <span key={k}>{k}</span>
        ))}
        {shape.hasBranching && <span className="suggestion-card__badge">branching</span>}
        {shape.hasVariables && <span className="suggestion-card__badge">variables</span>}
      </div>
    </button>
  );
}
// === /Task 38 ===
